import React from "react";

/** Minimal side-view car for nav road animation */
function NavMiniCar({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 28 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M3 9.5h2.2l1.4-3.2c.4-.9 1.2-1.5 2.2-1.5h9.6c1 0 1.8.6 2.2 1.5l1.4 3.2H25c.8 0 1.5.7 1.5 1.5v.5c0 .6-.4 1-1 1h-1.1a2.6 2.6 0 0 1-5 0H9.1a2.6 2.6 0 0 1-5 0H3c-.6 0-1-.4-1-1v-.5c0-.8.7-1.5 1.5-1.5Z"
        fill="currentColor"
      />
      <path
        d="M8.8 5.2h10.4l1.2 2.8H7.6l1.2-2.8Z"
        fill="currentColor"
        opacity="0.85"
      />
      <circle cx="8.5" cy="11" r="1.35" fill="#fff" stroke="currentColor" strokeWidth="0.75" />
      <circle cx="19.5" cy="11" r="1.35" fill="#fff" stroke="currentColor" strokeWidth="0.75" />
    </svg>
  );
}

export default NavMiniCar;
